import { render, staticRenderFns } from "./NewsPanel.vue?vue&type=template&id=40f5d504&scoped=true"
import script from "./NewsPanel.vue?vue&type=script&lang=js"
export * from "./NewsPanel.vue?vue&type=script&lang=js"
import style0 from "./NewsPanel.vue?vue&type=style&index=0&id=40f5d504&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f5d504",
  null
  
)

export default component.exports